import { Configuration, Convocatoria, ConvocatoriaApi } from '@/shared/formalizacion-client';
import { AxiosResponse } from 'axios';
import { Store } from 'vuex';

export default class ConvocatoriaService extends ConvocatoriaApi {
  constructor(microserviceConfigFormalizacion: Configuration, private store: Store<any>) {
    super(microserviceConfigFormalizacion);
  }

  private get convocatoria(): Convocatoria {
    return this.store.getters.convocatoria;
  }

  public getConvocatoria(clave: string): Promise<AxiosResponse<Convocatoria>> {
    const response = super
      .getConvocatoria(clave)
      .then(res => {
        this.store.commit('setConvocatoria', res.data);
        return Promise.resolve(res);
      })
      .catch(err => {
        return Promise.reject(err);
      });
    return response;
  }

  public getActualConvocatoria(): Convocatoria {
    return this.convocatoria;
  }

  public getActualConvocatoriaClave(): string {
    return this.convocatoria ? this.convocatoria.clave : null;
  }
}
